var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66732 3.33325C6.29913 3.33325 6.00065 3.63173 6.00065 3.99992C6.00065 4.36811 6.29913 4.66659 6.66732 4.66659L10.3912 4.66659L3.52925 11.5285C3.2689 11.7889 3.2689 12.211 3.52925 12.4713C3.7896 12.7317 4.21171 12.7317 4.47206 12.4713L11.334 5.60939L11.334 9.33325C11.334 9.70144 11.6325 9.99992 12.0007 9.99992C12.3688 9.99992 12.6673 9.70144 12.6673 9.33325L12.6673 3.99992C12.6673 3.63173 12.3688 3.33325 12.0007 3.33325L6.66732 3.33325Z",
    fill: "#8C8F93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchArrow);
export default __webpack_public_path__ + "static/media/search-arrow.fabdbf2c5c6be67d874b7bf418ba38a1.svg";
export { ForwardRef as ReactComponent };